<template>
  <div>
    <v-form v-model="valid" lazy-validation>
      <v-container :class="ui.bkgdColor">
        <v-layout row :class="ui.textSubheading">
          <div class="ml-4 mt-4">
            Company Registers
          </div>
        </v-layout>
        <v-container>
          <GetAccessListPage :data="{tag: 'G1', tagd: 'C1', tags: 'U1'}"
          v-if="this.licenceOK &&
          this.userOK &&
          this.getUser.pref.select.cauth !== null"/>
          <GetRegisterListPage :data="{tag: 'K6', tagd: 'F1', tags: 'C1'}"
          v-if="this.licenceOK &&
          this.userOK &&
          this.getUser.pref.select.cauth !== null"/>
          <GetRegisterListPage :data="{tag: 'K6', tagd: 'A.C1', tags: 'A.C1'}"
          v-if="this.licenceOK &&
          this.userOK &&
          this.getUser.pref.select.cauth !== null"/>
          <v-btn :color="ui.btnColor" flat light :disabled="true">
            <v-icon left>
              group
            </v-icon>
            Parnters and Vendors
          </v-btn>
          <GetRegisterListPage :data="{tag: 'K6', tagd: 'B3', tags: 'B3'}"/>
          <v-btn :color="ui.btnColor" flat light :disabled="true">
            <v-icon left>
              paid
            </v-icon>
            Spend Claim
          </v-btn>
          <v-btn :color="ui.btnColor" flat light :disabled="true">
            <v-icon left>
              account_tree
            </v-icon>
            Organisation
          </v-btn>
        </v-container>
        <v-layout row :class="ui.textSubheading">
          <div class="ml-4 mt-2 mb-2">
            Business and Strategy
          </div>
        </v-layout>
        <v-container>
          <GetRegisterListPage :data="{tag: 'K6', tagd: 'B6', tags: 'B6'}"/>
          <v-btn :color="ui.btnColor" flat light :disabled="true">
            <v-icon left>
              groups
            </v-icon>
            Business Processes
          </v-btn>
          <v-btn :color="ui.btnColor" flat light :disabled="true">
            <v-icon left>
              category
            </v-icon>
            Business Units
          </v-btn>
          <v-btn :color="ui.btnColor" flat light :disabled="true">
            <v-icon left>
              check_box_outline_blank
            </v-icon>
            Key Corporate Decisions
          </v-btn>
          <GetRegisterListPage :data="{tag: 'K6', tagd: 'B4', tags: 'B4'}"/>
          <v-btn :color="ui.btnColor" flat light :disabled="true">
            <v-icon left>
              attachment
            </v-icon>
            Documentation
          </v-btn>


          <!-- <v-layout align-left rowclass="mt-2 ml-4" :data="{btn: 'flat'}">
            <DataPrivacyCard/>
          </v-layout>
          <v-layout align-left rowclass="mt-2 ml-4">
            <TermsAndConditionsCard/>
          </v-layout>
          <v-layout align-left rowclass="mt-2 ml-4">
            <LicenceCard/>
          </v-layout> -->
        </v-container>
        <v-layout row class="mb-4">
        </v-layout>
        <v-layout row class="mb-4">
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import GetRegisterListPage from "@/data/register/components/GetRegisterListPage";
import GetAccessListPage from "@/support/access/components/GetAccessListPage";
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import ruleTextfield from "@/data/rules/mixins/rulesTextfield.js";
import tradeOptions from "@/data/options/mixins/tradeOptions.js";
import licenceFunctions from "@/admin/functions/mixins/licenceFunctions.js";
import adminFunctions from "@/admin/functions/mixins/adminFunctions.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
export default {
  components: {
    GetRegisterListPage,
    GetAccessListPage
  },
  mixins: [
    docRevsModFunctions,
    ruleTextfield,
    apptheme,
    tradeOptions,
    licenceFunctions,
    adminFunctions
  ]
  // components: {
  // }
};
</script>
